import { Check, Close, EditOutlined } from "@mui/icons-material";
import { Box, IconButton, Stack, Tooltip, Typography } from "@mui/material";
import { useState } from "react";

import { GradeSelector } from "@/shared/selectors/GradeSelector";
import { SupplierHeatRow } from "../models/ChemistryDraft";

type Props = {
	heat: SupplierHeatRow;
	canEdit: boolean;
	isSaving: boolean;
	onSave: (gradeId: number) => void;
};

export const GradeEditor = ({ heat, canEdit, isSaving, onSave }: Props) => {
	const [gradeId, setGradeId] = useState<number | null>(null);
	const [isEditing, setIsEditing] = useState(false);

	const startEdit = () => {
		setGradeId(heat.GradeId);
		setIsEditing(true);
	};

	const save = () => {
		if (gradeId == null || gradeId === heat.GradeId) return;
		onSave(gradeId);
		setIsEditing(false);
	};

	if (isEditing) {
		return (
			<Stack direction="row" spacing={0.5} alignItems="center">
				<Box sx={{ width: 180 }}>
					<GradeSelector label="" value={gradeId} onChange={setGradeId} />
				</Box>
				<Tooltip title="Save grade">
					<span>
						<IconButton
							size="small"
							color="primary"
							disabled={gradeId == null || gradeId === heat.GradeId}
							onClick={save}
							data-test-id="save-heat-grade"
						>
							<Check fontSize="small" />
						</IconButton>
					</span>
				</Tooltip>
				<Tooltip title="Cancel">
					<IconButton
						size="small"
						onClick={() => setIsEditing(false)}
						data-test-id="cancel-heat-grade"
					>
						<Close fontSize="small" />
					</IconButton>
				</Tooltip>
			</Stack>
		);
	}

	return (
		<Stack direction="row" spacing={0.5} alignItems="center">
			<Typography variant="body2" fontWeight={600}>
				{heat.Grade ?? "-"}
			</Typography>
			{canEdit && (
				<Tooltip title={heat.GradeId == null ? "Set grade" : "Change grade"}>
					<span>
						<IconButton
							size="small"
							color="primary"
							disabled={isSaving}
							onClick={startEdit}
							sx={{ p: 0.5 }}
							data-test-id="edit-heat-grade"
						>
							<EditOutlined sx={{ fontSize: 16 }} />
						</IconButton>
					</span>
				</Tooltip>
			)}
		</Stack>
	);
};
